import React from 'react';
import {Alert, Space} from 'antd';
import toast from 'react-hot-toast';
import {alertConstants} from '../constants';

const displayAlert = (message, variant, duration = 4000, width = 256) => {
  toast.custom(
    (t) => (
      <Space direction='vertical' style={{ width }}>
        <Alert
          message={message}
          onClose={() => toast.dismiss(t.id)}
          type={variant}
          closable
          showIcon
        />
      </Space>
    ),
    {duration}
  );
}

const success = (message, duration, width) => displayAlert(message, 'success', duration, width);

const warning = (message, duration, width) => displayAlert(message, 'warning', duration, width);

const error = (message, duration, width) => displayAlert(message, 'error', duration, width);

const clear = () => {
  return {
    type: alertConstants.CLEAR
  }
}

export const alertActions = {
  success,
  warning,
  error,
  clear
};
